import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { BlogListPage } from "./pages/BlogListPage";
import { BlogPostPage } from "./pages/BlogPostPage";
import { BufferProductsPage } from "./pages/BufferProductsPage";
import { CompanyPage } from "./pages/CompanyPage";
import { FundDetailPage } from "./pages/FundDetailPage";
import { GlossaryPage } from "./pages/GlossaryPage";
import { HomePage } from "./pages/HomePage";
import { LeveragedProductsPage } from "./pages/LeveragedProductsPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { ProductsPage } from "./pages/ProductsPage";
import { SocialMediaDisclaimerPage } from "./pages/SocialMediaDisclaimerPage";
import { TermsPage } from "./pages/TermsPage";
import { ThematicProductsPage } from "./pages/ThematicProductsPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "products", element: <ProductsPage /> },
      // Category landings — each redirects to /products?category=… (matches main).
      { path: "thematic", element: <ThematicProductsPage /> },
      { path: "2xleveraged", element: <LeveragedProductsPage /> },
      { path: "buffered", element: <BufferProductsPage /> },
      { path: "company", element: <CompanyPage /> },
      { path: "blog", element: <BlogListPage /> },
      { path: "blog/:slug", element: <BlogPostPage /> },
      { path: "glossary", element: <GlossaryPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "terms", element: <TermsPage /> },
      {
        path: "social-media-disclaimer",
        element: <SocialMediaDisclaimerPage />,
      },
      // Fund detail canonical route — must stay last so the more specific
      // routes above win when their paths happen to be one segment too.
      { path: ":slug", element: <FundDetailPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
